module.exports = __webpack_public_path__ + "img/album14_22.b9c645b5.jpg";